// 虚拟工厂
<template>
  <div class="admin">
    <div class="submit"><el-button type="primary"  @click="submitForm">保存</el-button><span class="tip">操作后务必保存，以免数据丢失</span></div>
    <el-form :model="jsonData" ref="jsonData" label-width="80px">
      <div v-show="$parent.subMenuId===1" name="工厂总览">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="园区总览" name="first">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="园区总览" label-width="100px">
                  <MzInput v-model.trim="jsonData.subpage.yqzl" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="设备概览" name="second">
            <el-row :gutter="10">
              <el-col :span="8" v-for="(item,index) in jsonData.subpage.sbgl" :key="index">
                <el-card class="box-card">
                  <el-form-item :label="item.name" label-width="100px">
                    <el-select v-model="item.status">
                      <el-option value="运行中" label="运行中"></el-option>
                      <el-option value="调试中" label="调试中"></el-option>
                      <el-option value="建设中" label="建设中"></el-option>
                    </el-select>
                  </el-form-item>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="能耗统计" name="third">
            <el-row :gutter="10">
              <el-col :span="2" class="label">
                <p>能耗类型</p>
                <el-button type="primary" size="small" @click="rightData2('sub_nhtj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.subpage">
                <div v-for="(item,index) in jsonData.subpage.nhtj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('sub_nhtj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('sub_nhtj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('sub_nhtj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('sub_nhtj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="环境监测" name="four">
            <el-row :gutter="10" v-for="(item,index) in jsonData.subpage.hjjc" :key="index">
              <el-col :span="24">
                <el-form-item label="类别" label-width="40px">
                    <MzInput v-model.trim="item.name" placeholder="请输入" style="width:50%"></MzInput>
                  </el-form-item>
              </el-col>
              <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                <el-card class="box-card">
                  <el-form-item label="名称" label-width="40px">
                    <MzInput v-model.trim="it.name" placeholder="请输入"></MzInput>
                  </el-form-item>
                  <el-form-item label="值" label-width="40px">
                    <MzInput v-model.trim="it.value" placeholder="请输入"></MzInput>
                  </el-form-item>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="监控视频" name="five">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="监控视频链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.subpage.jksp" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===2" name="二号工厂">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="能耗统计" name="first">
            <el-row :gutter="10">
              <el-col :span="2" class="label">
                <p>能耗类型</p>
                <el-button type="primary" size="small" @click="rightData2('detail_nhtj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.detail">
                <div v-for="(item,index) in jsonData.detail.nhtj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('detail_nhtj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('detail_nhtj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('detail_nhtj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('detail_nhtj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="设备监测" name="second">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="4" v-for="(item,index) in jsonData.detail.sbjc" :key="index">
                <el-form-item :label="item.name" label-width="60px">
                  <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="报警信息" name="third">
            <el-row :gutter="10" v-if="jsonData.detail">
              <el-col :span="4" v-for="(item,index) in jsonData.detail.bjxx" :key="index">
                <el-form-item :label="item.name" label-width="100px">
                  <MzInput v-model.trim="item.value" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="监控视频" name="four">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="监控视频链接" label-width="100px">
                  <MzInput v-model.trim="jsonData.detail.jksp" placeholder="视频格式mp4"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===3" name="设备模型详情">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="工厂概况" name="first">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="工厂概况" label-width="100px">
                  <MzInput v-model.trim="jsonData.info.gcgk" type="textarea" :rows="10" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="能耗统计" name="second">
            <el-row :gutter="10">
              <el-col :span="2" class="label">
                <p>能耗类型</p>
                <el-button type="primary" size="small" @click="rightData2('info_nhtj',0,'add')">添加系列</el-button>
              </el-col>
              <el-col :span="22" style="min-height:120px" v-if="jsonData.info">
                <div v-for="(item,index) in jsonData.info.nhtj" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="rightData2('info_nhtj',0,'del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                    <el-row :gutter="10" style="margin-bottom:10px">
                      <el-col :span="4">
                        <el-form-item label="名称" label-width="40px">
                          <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-button type="primary" size="small" @click.stop="rightData2('info_nhtj',1,'add')">添加月份</el-button>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="4" v-for="(it,i) in item.data" :key="i">
                          <el-card class="box-card">
                            <span class="del" @click.stop="rightData2('info_nhtj',1,'del',i)" style="left:0"><i class="el-icon-circle-close"></i></span>
                            <el-form-item label="月份" label-width="40px">
                                <MzInput v-model.trim="it.name" placeholder="请输入" @input="changeData('info_nhtj',i,it.name)"></MzInput>
                              </el-form-item>
                              <el-form-item label="值" label-width="40px">
                                <MzInput v-model.number="it.value" placeholder="请输入"></MzInput>
                              </el-form-item>
                          </el-card>
                        </el-col>
                    </el-row>
                  </el-card>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-form>
  </div>
</template>

<script>

import axios from "axios"
import mzfile from '@/components/mz_upload/index';
import mzfile2 from '@/components/mz_upload/fileUpload';
export default {
  components: {mzfile,mzfile2},
  name: '',
  data() {
    return {
      activeNames: [],
      tabActive: 'first',
      fileHandle: null,
      jsonData: {subpage:'',detail:'',info:''},
    };
  },
  created() {
    // this.jsonData = {
    //   subpage:{
    //     jksp: '',
    //     yqzl: '牦牛酪蛋白数智孪生工厂系统，以物理工厂为核心，构建全流程虚拟映射模型。系统整合原料、生产、质控、仓储全环节数据，实时同步牦牛乳验收、萃取、低温干燥等关键工序参数，动态呈现设备运行状态与能耗数据。\n通过 AI 算法分析能耗管理模块，实时监测各工序耗电量、蒸汽消耗量，生成能耗趋势图与单位产品能耗指标，对比分析各设备能耗差异，辅助优化高耗设备运行策略。通过设备与能耗数据的联动分析，实现故障提前预判、能耗精准管控，助力工厂降本增效，保障牦牛酪蛋白生产稳定。',
    //     sbgl: [{name:'数字赋能中心',status:'运行中'},{name:'一号工厂',status:'运行中'},{name:'二号工厂',status:'调试中'},{name:'动力车间',status:'运行中'},{name:'科技小院',status:'建设中'}],
    //     nhtj: [{
    //         "name": "电",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //     },
    //     {
    //         "name": "水",
    //         "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //     },
    //     {
    //         "name": "生物燃料",
    //         "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //     }],
    //     hjjc: [{
    //         name:'室外环境',data:[{name:"湿度",value:'50%'},{name:"温度",value:'23°'},{name:"风力",value:'3.5m/h'}]
    //       },{
    //         name:'室内环境',data:[{name:"湿度",value:'50%'},{name:"温度",value:'23°'},{name:"风力",value:'3.5m/h'}]
    //       }
    //     ]
    //   },
    //   detail: {
    //     jksp: '',
    //     nhtj: [{
    //         "name": "水能",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //     },
    //     {
    //         "name": "电能",
    //         "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //     },
    //     {
    //         "name": "生物耗能",
    //         "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //     }],
    //     sbjc: [{name:"电压",value:120},{name:"功率",value:6.1},{name:"效率",value:106.5},{name:"容量",value:100},{name:"温度",value:1.8},{name:"压力",value:1.3}],
    //     bjxx: [{name:"空气状况",value:'二级'},{name:"当日最高温度",value:'23°'},{name:"当日相对湿度",value:'50%'},{name:"1号机功率",value:'6kw/h'},{name:"2号机功率",value:'3kw/h'},{name:"负荷",value:'2w'}]
    //   },
    //   info: {
    //     gcgk: '工厂依托京东方数字化优势，打通采购、生产、研发等系统孤岛，实现设备互联、生产透明及AI辅助决策。\n新建车间含1条数字化酪蛋白生产线，配套环保设施，年产3000吨，完善“牧区原料-精深加工-市场”产业链，带动牧民增收。\n二楼设数字展示中心，大屏呈现车间实时数据，搭互动平台，整合产学研资源，助力科普、市场对接与产业创新。',
    //     nhtj: [{
    //         "name": "水能",
    //         "data": [{"name":"一月","value":22},{"name":"二月","value":38},{"name":"三月","value":28},{"name":"四月","value":38},{"name":"五月","value":35}]
    //     },
    //     {
    //         "name": "电能",
    //         "data": [{"name":"一月","value":27},{"name":"二月","value":33},{"name":"三月","value":25},{"name":"四月","value":34},{"name":"五月","value":34}]
    //     },
    //     {
    //         "name": "生物耗能",
    //         "data": [{"name":"一月","value":15},{"name":"二月","value":22},{"name":"三月","value":12},{"name":"四月","value":21},{"name":"五月","value":30}]
    //     }]
    //   }
    // }
    this.getData('modelXl')
  },
  watch:{
    '$parent.subMenuId':{
      handler(){
        this.tabActive = 'first'
      }
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
        }
      })
    },
    saveData(name){
      let params = {
        fileName: name,
        fileData: this.jsonData
      }
      axios.post(this.$baseUrl+'/api/web/file/data/save',params).then(res => {
        if(res.data.code === 200){
          this.$message({
            message: res.data.msg,
            type: 'success',
            customClass: 'adminMsg'
          });
          this.getData('modelXl')
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error',
            customClass: 'adminMsg'
          });
        }
      })
    },
    updateData(type,btn,index){
      if(btn==='add'){
        if(type==='jqg'){
          this.jsonData.jqg.push({name:'',imageUrl:'',videoUrl:''})
        }else if(type==='jsln'){
          this.jsonData.jsln.push({url:''})
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type==='jqg'){
            this.jsonData.jqg.splice(index,1)
          }else if(type==='jsln'){
            this.jsonData.jsln.splice(index,1)
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    rightData2(from,type,btn,index){
      if(btn==='add'){
        if(type===0 && from==='sub_nhtj'){
          // 添加能耗类型
          let data = []
          this.jsonData.subpage.nhtj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.subpage.nhtj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='sub_nhtj'){
          // 添加能耗日期
          this.jsonData.subpage.nhtj = this.jsonData.subpage.nhtj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='detail_nhtj'){
          // 添加能耗类型
          let data = []
          this.jsonData.detail.nhtj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.detail.nhtj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='detail_nhtj'){
          // 添加能耗日期
          this.jsonData.detail.nhtj = this.jsonData.detail.nhtj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }else if(type===0 && from==='info_nhtj'){
          // 添加能耗类型
          let data = []
          this.jsonData.info.nhtj[0].data.forEach(it => {
            data.push({name:it.name,value:''})
          })
          this.jsonData.info.nhtj.push({
            name: '',
            data: data
          })
        }else if(type===1 && from==='info_nhtj'){
          // 添加能耗日期
          this.jsonData.info.nhtj = this.jsonData.info.nhtj.map(item  => {
            item.data.push({name:'',value:''})
            return item
          })
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type===0 && from==='sub_nhtj'){
            this.jsonData.subpage.nhtj.splice(index,1)
          }else if(type===1 && from==='sub_nhtj'){
            this.jsonData.subpage.nhtj = this.jsonData.subpage.nhtj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='detail_nhtj'){
            this.jsonData.detail.nhtj.splice(index,1)
          }else if(type===1 && from==='detail_nhtj'){
            this.jsonData.detail.nhtj = this.jsonData.detail.nhtj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }else if(type===0 && from==='info_nhtj'){
            this.jsonData.info.nhtj.splice(index,1)
          }else if(type===1 && from==='info_nhtj'){
            this.jsonData.info.nhtj = this.jsonData.info.nhtj.map(item  => {
              item.data.splice(index,1)
              return item
            })
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    changeData(type,index,value){
      if(type==='sub_nhtj'){
        this.jsonData.subpage.nhtj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='detail_nhtj'){
        this.jsonData.detail.nhtj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }else if(type==='info_nhtj'){
        this.jsonData.info.nhtj.forEach(item => {
          item.data.forEach((it,i) => {
            if(i === index){
              it.name = value
            }
          })
        })
      }
    },
    submitForm(){
      this.$confirm('此操作将覆盖原有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.initFile()
        this.saveData('modelXl')
      }).catch(() => {
        console.log("已取消")         
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/admin';
</style>